// src/IT/components/ActivityTable.jsx
// Migrated from a hand-rolled <table> onto the shared DataTable.
import { useMemo } from "react";
import DataTable from "../../shared/ui/DataTable/index.jsx";

export default function ActivityTable({ events }) {
  const rows = events || [];

  const columns = useMemo(
    () => [
      {
        accessorKey: "created_at",
        header: "Time",
        width: 180,
        cell: ({ getValue }) => new Date(getValue()).toLocaleString(),
      },
      { accessorKey: "event_type", header: "Event", width: 140 },
      {
        accessorKey: "actor_email",
        header: "By",
        width: 200,
        cell: ({ getValue }) => getValue() || "-",
      },
      {
        accessorKey: "message",
        header: "Message",
        cell: ({ getValue }) => <span style={{ whiteSpace: "pre-wrap" }}>{getValue() || "-"}</span>,
      },
    ],
    []
  );

  return (
    <div className="it-card">
      <div className="it-card-title">Activity</div>
      <DataTable
        table={{ columns, rows }}
        entriesPerPage={{ defaultValue: 10, entries: [10, 25, 50] }}
        emptyMessage="No activity yet."
      />
    </div>
  );
}
